import { render, staticRenderFns } from "./DeliveryActions.vue?vue&type=template&id=1ddf86ad&scoped=true&"
import script from "./DeliveryActions.vue?vue&type=script&lang=js&"
export * from "./DeliveryActions.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryActions.vue?vue&type=style&index=0&id=1ddf86ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf86ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
